/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Price_Minimum_BidInputs */

const cs_sreality_attr_price_minimum_bid = /** @type {(inputs: Sreality_Attr_Price_Minimum_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimální příhoz`)
};

const en_sreality_attr_price_minimum_bid = /** @type {(inputs: Sreality_Attr_Price_Minimum_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum bid`)
};

/**
* | output |
* | --- |
* | "Minimum bid" |
*
* @param {Sreality_Attr_Price_Minimum_BidInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_price_minimum_bid = /** @type {((inputs?: Sreality_Attr_Price_Minimum_BidInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Price_Minimum_BidInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_price_minimum_bid(inputs)
	return cs_sreality_attr_price_minimum_bid(inputs)
});